import React from 'react';
import { Tabs } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PaymentDetails from './components/PaymentDetails';
import PaymentLogs from './components/PaymentLogs';
import { getPaymentCoreLogsService, getPaymentLogsService } from '../../../services/paymenSevices';
import useTranslation from '../../../../hooks/translation/useTranslation';

function PaymentPage() {
  const { trans } = useTranslation();
  const { state } = useLocation();
  return (
    <div className="flex flex-col gap-5">
      <Link
        to="/admin/payments"
        state={state || {}}
        className="w-fit"
      >
        <ArrowLeftOutlined
          style={{ fontSize: '20px' }}
        />
      </Link>
      <Tabs
        items={[{
          key: 'payment-details',
          label: trans('payment_info'),
          children: <PaymentDetails />,
        }, {
          key: 'payment-logs',
          label: trans('payment_logs'),
          children: <PaymentLogs getService={getPaymentLogsService} />,
        }, {
          key: 'core-logs',
          label: trans('core_logs'),
          children: <PaymentLogs getService={getPaymentCoreLogsService} />,
        }]}
      />
    </div>
  );
}

export default PaymentPage;
